import '../scss/chatbot.scss';

import { createRoot } from 'react-dom/client';
import ChatWidget from './ChatWidget.jsx';

document.addEventListener( 'DOMContentLoaded', function () {
	var mount = document.getElementById( 'od-chatbot-widget-root' );

	if ( ! mount || typeof odChatbotConfig === 'undefined' ) {
		return;
	}

	createRoot( mount ).render( <ChatWidget config={ odChatbotConfig } /> );
} );
